import Phaser from 'phaser';
import { RunScene, type RunLaunchOptions } from './scenes/RunScene';

export function createRunGame(parent: HTMLElement, options: RunLaunchOptions): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width: 540,
    height: 960,
    backgroundColor: '#07131f',
    transparent: false,
    antialias: true,
    pixelArt: false,
    roundPixels: false,
    render: {
      powerPreference: 'high-performance',
      antialiasGL: true,
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 540,
      height: 960,
    },
    input: {
      activePointers: 2,
      smoothFactor: 0.2,
    },
    scene: [new RunScene(options)],
    fps: {
      target: 60,
      min: 30,
      smoothStep: true,
    },
  });
}
